export const size = {
  mobile: 500,
  tablet: 769,
  laptop: 1025,
  desktop: 1500,
};
